import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

export const SUBSCRIPTION_OFFER_ACCEPT = gql(`
  mutation subscriptionOfferAccept($organizationId: ID!, $subscriptionOfferId: ID!) {
    subscriptionOfferAccept(organizationId: $organizationId, subscriptionOfferId: $subscriptionOfferId) {
      __typename
      ... on AppSubscription {
        __typename
        id
        app {
          __typename
          displayName
        }
        inboundOrganization {
          __typename
          slug
        }
      }
      ... on SubscriptionOfferCheckoutSession {
        __typename
        portalURL
      }
      ... on OrganizationMissingPaymentMethod {
        __typename
        organizationID
      }
      ... on SubscriptionOfferInvalidStatus {
        __typename
        id
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
    }
  }
`);

export function useSubscriptionOfferAccept() {
  return useMutation(SUBSCRIPTION_OFFER_ACCEPT);
}
